module.exports = __webpack_public_path__ + "img/pos--icon.a1a951fa.svg";